export class CallCenterVendaMensal {
  constructor(
    public mes: string,
    public valor: number,
    public variacao_percentual: number,
    public parcial: boolean
  ) { }
}
